import type { FC } from "react";
import { TriggerButton } from "widgets";

interface OpenInNewTabButtonProps {
  url: string;
}

export const OpenInNewTabButton: FC<OpenInNewTabButtonProps> = ({ url }) => {
  return (
    <TriggerButton
      icon={"open_in_new"}
      label={"Open in new tab"}
      onPress={() => window.open(url, "_blank")}
      showLabel
      isDisabled={!url}
    />
  );
};
